import {
  DEFAULT_API_FAILURE_MESSAGE,
  EXCLAMATION_ICON_TYPE,
  DEFAULT_API_FAILURE_TITLE,
  CLOCK_ICON_TYPE,
  INFORMATION_ICON_TYPE,
  RED_INFO_ICON_TYPE
} from "./constants";

export default class ErrorHandler {
  static handleApiError(error, goto, previousState, previousScreen) {
    const { errorMessage, errorMessageTitle } = this.getErrorMessage(error);
    const errorProps = {
      iconType: EXCLAMATION_ICON_TYPE,
      title: errorMessageTitle,
      message: errorMessage,
      primaryButtonInfo: {
        text: "OKAY",
        screen: previousScreen,
        previousState
      }
    };
    goto("INFORMATION_CARD", errorProps);
  }
  static handleLoginOtpRequestError(
    error,
    goto,
    previousState,
    previousScreen
  ) {
    if (error && error.response) {
      switch (error.response.status) {
        case 404: {
          // Non existent id
          const errorMessage = this.getErrorMessage(error).errorMessage;
          const errorProps = {
            iconType: EXCLAMATION_ICON_TYPE,
            title: "Sorry!",
            message: errorMessage,
            secondaryButtonInfo: {
              text: "REGISTER",
              screen: "CREATE_PROFILE"
            },
            primaryButtonInfo: {
              text: "RETRY",
              screen: previousScreen,
              previousState
            }
          };
          goto("INFORMATION_CARD", errorProps);
          return;
        }
        case 403: {
          const errorMessage = this.getErrorMessage(error).errorMessage;
          const errorProps = {
            iconType: RED_INFO_ICON_TYPE,
            title: "Sorry!",
            message: errorMessage,
            primaryButtonInfo: {
              text: "Okay",
              screen: previousScreen,
              previousState
            }
          };
          goto("INFORMATION_CARD", errorProps);
          return;
        }
        case 423: {
          const errorMessage = this.getErrorMessage(error).errorMessage;
          const errorProps = {
            iconType: EXCLAMATION_ICON_TYPE,
            title: "Sorry!",
            message: errorMessage,
            primaryButtonInfo: {
              text: "I forgot my password",
              screen: "FORGOT_PASSWORD",
              previousState
            },
            secondaryButtonInfo: {
              text: "Okay",
              screen: previousScreen,
              previousState
            },
          };
          goto("INFORMATION_CARD", errorProps);
          return;
        }

        default:
          break;
      }
    }
    this.handleApiError(error, goto, previousState, previousScreen);
  }
  static handleOtpLoginApiError(
    error,
    goto,
    previousState,
    previousScreen,
    resetScreenState
  ) {
    if (error && error.response) {
      switch (error.response.status) {
        case 423: {
          // OTP locked
          const errorProps = {
            iconType: INFORMATION_ICON_TYPE,
            title: "Invalid OTPs",
            message: this.getErrorMessage(error).errorMessage,

            primaryButtonInfo: {
              text: "OKAY",
              screen: "LOGIN_OTP",
              previousState: resetScreenState
            }
          };
          goto("INFORMATION_CARD", errorProps);
          return;
        }
        case 401: {
          // OTP locked
          const errorProps = {
            iconType: EXCLAMATION_ICON_TYPE,
            title: "Invalid OTP!",
            message: this.getErrorMessage(error).errorMessage,
            primaryButtonInfo: {
              text: "OKAY",
              screen: "ENTER_OTP",
              previousState
            }
          };
          goto("INFORMATION_CARD", errorProps);
          return;
        }
        default:
          break;
      }
    }
    this.handleApiError(error, goto, previousState, previousScreen);
  }
  static handleForgotUsernameApiError(
    error,
    goto,
    previousState,
    previousScreen
  ) {
    if (error && error.response) {
      switch (error.response.status) {
        case 404: {
          // Non existent id
          const errorProps = {
            iconType: INFORMATION_ICON_TYPE,
            title: "Sorry!",
            message: this.getErrorMessage(error).errorMessage,
            secondaryButtonInfo: {
              text: "REGISTER",
              screen: "CREATE_PROFILE"
            },
            primaryButtonInfo: {
              text: "RETRY",
              screen: previousScreen,
              previousState
            }
          };
          goto("INFORMATION_CARD", errorProps);
          return;
        }
        default:
          break;
      }
    }
    this.handleApiError(error, goto, previousState, previousScreen);
  }
  static handleForgotPasswordOtpRequestApiError(
    error,
    goto,
    previousState,
    previousScreen
  ) {
    if (error && error.response) {
      switch (error.response.status) {
        case 404: {
          // Non existent id
          const errorProps = {
            iconType: INFORMATION_ICON_TYPE,
            title: "Sorry!",
            message: this.getErrorMessage(error).errorMessage,
            secondaryButtonInfo: {
              text: "REGISTER",
              screen: "CREATE_PROFILE"
            },
            primaryButtonInfo: {
              text: "RETRY",
              screen: previousScreen,
              previousState
            }
          };
          goto("INFORMATION_CARD", errorProps);
          return;
        }
        case 403: {
          const errorProps = {
            iconType: CLOCK_ICON_TYPE,
            title: "Pending Registration",
            message: this.getErrorMessage(error).errorMessage,
            primaryButtonInfo: {
              text: "OKAY",
              screen: previousScreen,
              previousState
            }
          };
          goto("INFORMATION_CARD", errorProps);
          return;
        }
        default:
          break;
      }
    }
    this.handleApiError(error, goto, previousState, previousScreen);
  }

  static handleValidateForgotPasswordApiError(
    error,
    goto,
    previousState,
    previousScreen,
    resetScreenState
  ) {
    if (error && error.response) {
      switch (error.response.status) {
        case 423: {
          // OTP locked
          const errorProps = {
            iconType: INFORMATION_ICON_TYPE,
            title: "Invalid OTPs",
            message: this.getErrorMessage(error).errorMessage,

            primaryButtonInfo: {
              text: "OKAY",
              screen: "FORGOT_PASSWORD",
              previousState: resetScreenState
            }
          };
          goto("INFORMATION_CARD", errorProps);
          return;
        }
        default:
          break;
      }
    }
    this.handleApiError(error, goto, previousState, previousScreen);
  }
  static handleValidateOtpRegisterApiError(
    error,
    goto,
    previousState,
    previousScreen,
    resetScreenState
  ) {
    if (error && error.response) {
      switch (error.response.status) {
        case 423: {
          // OTP locked
          const errorProps = {
            iconType: INFORMATION_ICON_TYPE,
            title: "Invalid OTPs",
            message: this.getErrorMessage(error).errorMessage,
            primaryButtonInfo: {
              text: "OKAY",
              screen: "CREATE_PROFILE",
              previousState: resetScreenState
            }
          };
          goto("INFORMATION_CARD", errorProps);
          return;
        }
        default:
          break;
      }
    }
    this.handleApiError(error, goto, previousState, previousScreen);
  }
  static handleResendOtpError(error, notify, displayCaptcha) {
    if (error && error.response && error.response.status === 401) {
      displayCaptcha();
      notify(this.getErrorMessage(error).errorMessage);
      return false;
    }
    return true;
  }

  static handleTemporaryPassword(buttonInfo, goto) {

    const errorProps = {
      iconType: INFORMATION_ICON_TYPE,
      title: 'Reset your password',
      message: 'Please reset your password to continue.',
      primaryButtonInfo: {
        text: "Reset password",
        screen: "FORGOT_PASSWORD",
        ...buttonInfo
      }
    };

    goto("INFORMATION_CARD", errorProps);
  }

  static handleEmailActivationError(error, goto) {
    let { errorMessage, errorMessageTitle } = this.getErrorMessage(error);
    if (error && error.response && error.response.status === 400) {
      errorMessageTitle = "Email verification expired";
    }
    const errorProps = {
      iconType: EXCLAMATION_ICON_TYPE,
      title: errorMessageTitle,
      message: errorMessage,
      primaryButtonInfo: {
        text: "OKAY",
        screen: "CREATE_PROFILE"
      }
    };
    goto("INFORMATION_CARD", errorProps);
  }
  static getErrorMessage(error) {
    let errorMessage = DEFAULT_API_FAILURE_MESSAGE;
    let errorMessageTitle = DEFAULT_API_FAILURE_TITLE;
    if (error && error.response) {
      const { messages } = error.response.data || [];
      if (messages && messages.length) {
        errorMessage = messages[0].message;
        errorMessageTitle = "Sorry!";
      }
    }
    return { errorMessage, errorMessageTitle };
  }
}
